package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets11 {
  internal val _29_iyov_35_txt: AssetResource by lazy { init__29_iyov_35_txt() }

  internal val _29_iyov_36_txt: AssetResource by lazy { init__29_iyov_36_txt() }

  internal val _29_iyov_37_txt: AssetResource by lazy { init__29_iyov_37_txt() }

  internal val _29_iyov_38_txt: AssetResource by lazy { init__29_iyov_38_txt() }

  internal val _29_iyov_39_txt: AssetResource by lazy { init__29_iyov_39_txt() }

  internal val _29_iyov_40_txt: AssetResource by lazy { init__29_iyov_40_txt() }

  internal val _29_iyov_41_txt: AssetResource by lazy { init__29_iyov_41_txt() }

  internal val _29_iyov_42_txt: AssetResource by lazy { init__29_iyov_42_txt() }

  internal val _2_shemot_01_txt: AssetResource by lazy { init__2_shemot_01_txt() }

  internal val _2_shemot_02_txt: AssetResource by lazy { init__2_shemot_02_txt() }

  internal val _2_shemot_03_txt: AssetResource by lazy { init__2_shemot_03_txt() }

  internal val _2_shemot_04_txt: AssetResource by lazy { init__2_shemot_04_txt() }

  internal val _2_shemot_05_txt: AssetResource by lazy { init__2_shemot_05_txt() }

  internal val _2_shemot_06_txt: AssetResource by lazy { init__2_shemot_06_txt() }

  internal val _2_shemot_07_txt: AssetResource by lazy { init__2_shemot_07_txt() }

  internal val _2_shemot_08_txt: AssetResource by lazy { init__2_shemot_08_txt() }

  internal val _2_shemot_09_txt: AssetResource by lazy { init__2_shemot_09_txt() }

  internal val _2_shemot_10_txt: AssetResource by lazy { init__2_shemot_10_txt() }

  internal val _2_shemot_11_txt: AssetResource by lazy { init__2_shemot_11_txt() }

  internal val _2_shemot_12_txt: AssetResource by lazy { init__2_shemot_12_txt() }

  internal val _2_shemot_13_txt: AssetResource by lazy { init__2_shemot_13_txt() }

  internal val _2_shemot_14_txt: AssetResource by lazy { init__2_shemot_14_txt() }

  internal val _2_shemot_15_txt: AssetResource by lazy { init__2_shemot_15_txt() }

  internal val _2_shemot_16_txt: AssetResource by lazy { init__2_shemot_16_txt() }

  internal val _2_shemot_17_txt: AssetResource by lazy { init__2_shemot_17_txt() }

  internal val _2_shemot_18_txt: AssetResource by lazy { init__2_shemot_18_txt() }

  internal val _2_shemot_19_txt: AssetResource by lazy { init__2_shemot_19_txt() }

  internal val _2_shemot_20_txt: AssetResource by lazy { init__2_shemot_20_txt() }

  internal val _2_shemot_21_txt: AssetResource by lazy { init__2_shemot_21_txt() }

  internal val _2_shemot_22_txt: AssetResource by lazy { init__2_shemot_22_txt() }

  internal val _2_shemot_23_txt: AssetResource by lazy { init__2_shemot_23_txt() }

  internal val _2_shemot_24_txt: AssetResource by lazy { init__2_shemot_24_txt() }

  internal val _2_shemot_25_txt: AssetResource by lazy { init__2_shemot_25_txt() }

  internal val _2_shemot_26_txt: AssetResource by lazy { init__2_shemot_26_txt() }

  internal val _2_shemot_27_txt: AssetResource by lazy { init__2_shemot_27_txt() }

  internal val _2_shemot_28_txt: AssetResource by lazy { init__2_shemot_28_txt() }

  internal val _2_shemot_29_txt: AssetResource by lazy { init__2_shemot_29_txt() }

  internal val _2_shemot_30_txt: AssetResource by lazy { init__2_shemot_30_txt() }

  internal val _2_shemot_31_txt: AssetResource by lazy { init__2_shemot_31_txt() }

  internal val _2_shemot_32_txt: AssetResource by lazy { init__2_shemot_32_txt() }

  internal val _2_shemot_33_txt: AssetResource by lazy { init__2_shemot_33_txt() }

  internal val _2_shemot_34_txt: AssetResource by lazy { init__2_shemot_34_txt() }

  internal val _2_shemot_35_txt: AssetResource by lazy { init__2_shemot_35_txt() }

  internal val _2_shemot_36_txt: AssetResource by lazy { init__2_shemot_36_txt() }

  internal val _2_shemot_37_txt: AssetResource by lazy { init__2_shemot_37_txt() }

  internal val _2_shemot_38_txt: AssetResource by lazy { init__2_shemot_38_txt() }

  internal val _2_shemot_39_txt: AssetResource by lazy { init__2_shemot_39_txt() }

  internal val _2_shemot_40_txt: AssetResource by lazy { init__2_shemot_40_txt() }

  internal val _30_shir_hashirim_01_txt: AssetResource by lazy { init__30_shir_hashirim_01_txt() }

  internal val _30_shir_hashirim_02_txt: AssetResource by lazy { init__30_shir_hashirim_02_txt() }

  internal fun values(): List<AssetResource> = listOf(_29_iyov_35_txt, _29_iyov_36_txt,
      _29_iyov_37_txt, _29_iyov_38_txt, _29_iyov_39_txt, _29_iyov_40_txt, _29_iyov_41_txt,
      _29_iyov_42_txt, _2_shemot_01_txt, _2_shemot_02_txt, _2_shemot_03_txt, _2_shemot_04_txt,
      _2_shemot_05_txt, _2_shemot_06_txt, _2_shemot_07_txt, _2_shemot_08_txt, _2_shemot_09_txt,
      _2_shemot_10_txt, _2_shemot_11_txt, _2_shemot_12_txt, _2_shemot_13_txt, _2_shemot_14_txt,
      _2_shemot_15_txt, _2_shemot_16_txt, _2_shemot_17_txt, _2_shemot_18_txt, _2_shemot_19_txt,
      _2_shemot_20_txt, _2_shemot_21_txt, _2_shemot_22_txt, _2_shemot_23_txt, _2_shemot_24_txt,
      _2_shemot_25_txt, _2_shemot_26_txt, _2_shemot_27_txt, _2_shemot_28_txt, _2_shemot_29_txt,
      _2_shemot_30_txt, _2_shemot_31_txt, _2_shemot_32_txt, _2_shemot_33_txt, _2_shemot_34_txt,
      _2_shemot_35_txt, _2_shemot_36_txt, _2_shemot_37_txt, _2_shemot_38_txt, _2_shemot_39_txt,
      _2_shemot_40_txt, _30_shir_hashirim_01_txt, _30_shir_hashirim_02_txt)
}

private fun init__29_iyov_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-35.txt\")") as String, rawPath =
    "allChapters/_29_iyov-35.txt")

private fun init__29_iyov_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-36.txt\")") as String, rawPath =
    "allChapters/_29_iyov-36.txt")

private fun init__29_iyov_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-37.txt\")") as String, rawPath =
    "allChapters/_29_iyov-37.txt")

private fun init__29_iyov_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-38.txt\")") as String, rawPath =
    "allChapters/_29_iyov-38.txt")

private fun init__29_iyov_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-39.txt\")") as String, rawPath =
    "allChapters/_29_iyov-39.txt")

private fun init__29_iyov_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-40.txt\")") as String, rawPath =
    "allChapters/_29_iyov-40.txt")

private fun init__29_iyov_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-41.txt\")") as String, rawPath =
    "allChapters/_29_iyov-41.txt")

private fun init__29_iyov_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_29_iyov-42.txt\")") as String, rawPath =
    "allChapters/_29_iyov-42.txt")

private fun init__2_shemot_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-01.txt\")") as String, rawPath =
    "allChapters/_2_shemot-01.txt")

private fun init__2_shemot_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-02.txt\")") as String, rawPath =
    "allChapters/_2_shemot-02.txt")

private fun init__2_shemot_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-03.txt\")") as String, rawPath =
    "allChapters/_2_shemot-03.txt")

private fun init__2_shemot_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-04.txt\")") as String, rawPath =
    "allChapters/_2_shemot-04.txt")

private fun init__2_shemot_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-05.txt\")") as String, rawPath =
    "allChapters/_2_shemot-05.txt")

private fun init__2_shemot_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-06.txt\")") as String, rawPath =
    "allChapters/_2_shemot-06.txt")

private fun init__2_shemot_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-07.txt\")") as String, rawPath =
    "allChapters/_2_shemot-07.txt")

private fun init__2_shemot_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-08.txt\")") as String, rawPath =
    "allChapters/_2_shemot-08.txt")

private fun init__2_shemot_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-09.txt\")") as String, rawPath =
    "allChapters/_2_shemot-09.txt")

private fun init__2_shemot_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-10.txt\")") as String, rawPath =
    "allChapters/_2_shemot-10.txt")

private fun init__2_shemot_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-11.txt\")") as String, rawPath =
    "allChapters/_2_shemot-11.txt")

private fun init__2_shemot_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-12.txt\")") as String, rawPath =
    "allChapters/_2_shemot-12.txt")

private fun init__2_shemot_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-13.txt\")") as String, rawPath =
    "allChapters/_2_shemot-13.txt")

private fun init__2_shemot_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-14.txt\")") as String, rawPath =
    "allChapters/_2_shemot-14.txt")

private fun init__2_shemot_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-15.txt\")") as String, rawPath =
    "allChapters/_2_shemot-15.txt")

private fun init__2_shemot_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-16.txt\")") as String, rawPath =
    "allChapters/_2_shemot-16.txt")

private fun init__2_shemot_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-17.txt\")") as String, rawPath =
    "allChapters/_2_shemot-17.txt")

private fun init__2_shemot_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-18.txt\")") as String, rawPath =
    "allChapters/_2_shemot-18.txt")

private fun init__2_shemot_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-19.txt\")") as String, rawPath =
    "allChapters/_2_shemot-19.txt")

private fun init__2_shemot_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-20.txt\")") as String, rawPath =
    "allChapters/_2_shemot-20.txt")

private fun init__2_shemot_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-21.txt\")") as String, rawPath =
    "allChapters/_2_shemot-21.txt")

private fun init__2_shemot_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-22.txt\")") as String, rawPath =
    "allChapters/_2_shemot-22.txt")

private fun init__2_shemot_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-23.txt\")") as String, rawPath =
    "allChapters/_2_shemot-23.txt")

private fun init__2_shemot_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-24.txt\")") as String, rawPath =
    "allChapters/_2_shemot-24.txt")

private fun init__2_shemot_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-25.txt\")") as String, rawPath =
    "allChapters/_2_shemot-25.txt")

private fun init__2_shemot_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-26.txt\")") as String, rawPath =
    "allChapters/_2_shemot-26.txt")

private fun init__2_shemot_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-27.txt\")") as String, rawPath =
    "allChapters/_2_shemot-27.txt")

private fun init__2_shemot_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-28.txt\")") as String, rawPath =
    "allChapters/_2_shemot-28.txt")

private fun init__2_shemot_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-29.txt\")") as String, rawPath =
    "allChapters/_2_shemot-29.txt")

private fun init__2_shemot_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-30.txt\")") as String, rawPath =
    "allChapters/_2_shemot-30.txt")

private fun init__2_shemot_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-31.txt\")") as String, rawPath =
    "allChapters/_2_shemot-31.txt")

private fun init__2_shemot_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-32.txt\")") as String, rawPath =
    "allChapters/_2_shemot-32.txt")

private fun init__2_shemot_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-33.txt\")") as String, rawPath =
    "allChapters/_2_shemot-33.txt")

private fun init__2_shemot_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-34.txt\")") as String, rawPath =
    "allChapters/_2_shemot-34.txt")

private fun init__2_shemot_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-35.txt\")") as String, rawPath =
    "allChapters/_2_shemot-35.txt")

private fun init__2_shemot_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-36.txt\")") as String, rawPath =
    "allChapters/_2_shemot-36.txt")

private fun init__2_shemot_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-37.txt\")") as String, rawPath =
    "allChapters/_2_shemot-37.txt")

private fun init__2_shemot_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-38.txt\")") as String, rawPath =
    "allChapters/_2_shemot-38.txt")

private fun init__2_shemot_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-39.txt\")") as String, rawPath =
    "allChapters/_2_shemot-39.txt")

private fun init__2_shemot_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_2_shemot-40.txt\")") as String, rawPath =
    "allChapters/_2_shemot-40.txt")

private fun init__30_shir_hashirim_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-01.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-01.txt")

private fun init__30_shir_hashirim_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_30_shir_hashirim-02.txt\")") as String, rawPath =
    "allChapters/_30_shir_hashirim-02.txt")

public actual val SharedRes.assets.allChapters._29_iyov_35_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_35_txt

public actual val SharedRes.assets.allChapters._29_iyov_36_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_36_txt

public actual val SharedRes.assets.allChapters._29_iyov_37_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_37_txt

public actual val SharedRes.assets.allChapters._29_iyov_38_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_38_txt

public actual val SharedRes.assets.allChapters._29_iyov_39_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_39_txt

public actual val SharedRes.assets.allChapters._29_iyov_40_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_40_txt

public actual val SharedRes.assets.allChapters._29_iyov_41_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_41_txt

public actual val SharedRes.assets.allChapters._29_iyov_42_txt: AssetResource
  get() = CommonMainAssets11._29_iyov_42_txt

public actual val SharedRes.assets.allChapters._2_shemot_01_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_01_txt

public actual val SharedRes.assets.allChapters._2_shemot_02_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_02_txt

public actual val SharedRes.assets.allChapters._2_shemot_03_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_03_txt

public actual val SharedRes.assets.allChapters._2_shemot_04_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_04_txt

public actual val SharedRes.assets.allChapters._2_shemot_05_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_05_txt

public actual val SharedRes.assets.allChapters._2_shemot_06_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_06_txt

public actual val SharedRes.assets.allChapters._2_shemot_07_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_07_txt

public actual val SharedRes.assets.allChapters._2_shemot_08_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_08_txt

public actual val SharedRes.assets.allChapters._2_shemot_09_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_09_txt

public actual val SharedRes.assets.allChapters._2_shemot_10_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_10_txt

public actual val SharedRes.assets.allChapters._2_shemot_11_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_11_txt

public actual val SharedRes.assets.allChapters._2_shemot_12_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_12_txt

public actual val SharedRes.assets.allChapters._2_shemot_13_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_13_txt

public actual val SharedRes.assets.allChapters._2_shemot_14_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_14_txt

public actual val SharedRes.assets.allChapters._2_shemot_15_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_15_txt

public actual val SharedRes.assets.allChapters._2_shemot_16_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_16_txt

public actual val SharedRes.assets.allChapters._2_shemot_17_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_17_txt

public actual val SharedRes.assets.allChapters._2_shemot_18_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_18_txt

public actual val SharedRes.assets.allChapters._2_shemot_19_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_19_txt

public actual val SharedRes.assets.allChapters._2_shemot_20_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_20_txt

public actual val SharedRes.assets.allChapters._2_shemot_21_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_21_txt

public actual val SharedRes.assets.allChapters._2_shemot_22_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_22_txt

public actual val SharedRes.assets.allChapters._2_shemot_23_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_23_txt

public actual val SharedRes.assets.allChapters._2_shemot_24_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_24_txt

public actual val SharedRes.assets.allChapters._2_shemot_25_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_25_txt

public actual val SharedRes.assets.allChapters._2_shemot_26_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_26_txt

public actual val SharedRes.assets.allChapters._2_shemot_27_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_27_txt

public actual val SharedRes.assets.allChapters._2_shemot_28_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_28_txt

public actual val SharedRes.assets.allChapters._2_shemot_29_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_29_txt

public actual val SharedRes.assets.allChapters._2_shemot_30_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_30_txt

public actual val SharedRes.assets.allChapters._2_shemot_31_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_31_txt

public actual val SharedRes.assets.allChapters._2_shemot_32_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_32_txt

public actual val SharedRes.assets.allChapters._2_shemot_33_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_33_txt

public actual val SharedRes.assets.allChapters._2_shemot_34_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_34_txt

public actual val SharedRes.assets.allChapters._2_shemot_35_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_35_txt

public actual val SharedRes.assets.allChapters._2_shemot_36_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_36_txt

public actual val SharedRes.assets.allChapters._2_shemot_37_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_37_txt

public actual val SharedRes.assets.allChapters._2_shemot_38_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_38_txt

public actual val SharedRes.assets.allChapters._2_shemot_39_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_39_txt

public actual val SharedRes.assets.allChapters._2_shemot_40_txt: AssetResource
  get() = CommonMainAssets11._2_shemot_40_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_01_txt: AssetResource
  get() = CommonMainAssets11._30_shir_hashirim_01_txt

public actual val SharedRes.assets.allChapters._30_shir_hashirim_02_txt: AssetResource
  get() = CommonMainAssets11._30_shir_hashirim_02_txt
